import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FormlyDialogComponent, FormlyDialogData } from 'ng2-app/components/formly-dialog/formly-dialog.component';
import { Offer } from 'app/services/offers/offer.model';
import { of } from 'rxjs';
import { OfferFormFields } from '../offer.formly-fields';

@Component({
  selector: 'app-create-offer-button',
  templateUrl: './create-offer-button.component.html',
  styleUrls: ['./create-offer-button.component.scss']
})
export class CreateOfferButtonComponent implements OnInit {

  @Input() dealId: number;
  @Input() loanProductType: string;
  @Input() offerNumber: number;

  @Output() createOffer = new EventEmitter<Offer>();

  offerFormFields = new OfferFormFields();
  model = {};

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {}

  handleCreate() {
    const dialogRef = this.dialog.open(FormlyDialogComponent, {
      data: this.formlyDialogData(),
      width: '60rem',
      panelClass: 'offer-form-dialog'
    });
    dialogRef.componentInstance.saveData.subscribe(data => {
      const offerData = data.formlyConfig.form.value;
      if (offerData.costType) {
        offerData[offerData.costType] = offerData.cost;
      }
      this.createOffer.emit(offerData);
      dialogRef.close();
    });
  }

  private formlyDialogData(): FormlyDialogData {
    return {
      loading$: of(false),
      title: `Add New Offer (Offer ${this.offerNumber})`,
      formlyConfig: {
        model: this.model,
        form: new UntypedFormGroup({}),
        fields: this.loanProductType !== 'factoring' ? this.offerFormFields.getOfferFields
          : this.offerFormFields.getFactoringFields,
        options: {
          formState: {
            mainModel: this.model
          }
        }
      }
    };
  }
}
